/* */ 
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tryStringify = exports.tryParse = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var tryParse = function tryParse(obj) {
  try {
    return JSON.parse(obj);
  } catch (ex) {
    // FAIL loggin
    return obj;
  }
};

exports.tryParse = tryParse;

var tryStringify = function tryStringify(obj) {
  if (_typeof(obj) === 'object' && obj !== null) {
    try {
      return JSON.stringify(obj);
    } catch (ex) {
      // FAIL loggin
      return obj;
    }
  }

  return obj;
};

exports.tryStringify = tryStringify;